export default __webpack_public_path__ + "static/media/icn-target-active.c0a68720.svg";